







































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import SalesReportConfirmDialogProducts, {
  SalesReportSubmittedProduct,
} from '@/components/salesreport/ConfirmDialogProducts.vue';
import { AppModule } from '@/store/modules/app';
import {
  stringToNumber,
  formatDate,
  stringToIDate,
  formatApiError,
  stringFromIDate,
  translateViewResource,
  monthStringToIDate,
  monthStringFromIDate,
} from '@/utils/index';
import { translateRouteTitle } from '@/utils/permission';
import { agentSummaryById } from '@/utils/agent';
import { productById } from '@/utils/product';
import { list_product_summaries, listProductSummaries } from '@/api/product';
import {
  get_agency_sales_report_detail,
  getAgencySalesReportDetail,
  put_agency_sales_report,
  putAgencySalesReport,
  calculate_agency_inventory_sales,
  calculateAgencyInventorySales,
} from '@/api/salesreport';
import { ProductTypeEnum } from '@/api/types';

type ItemType = {
  text: string;
  value: string;
};

@Component({
  name: 'SalesReportEdit',
  components: {
    MaterialCard,
    SalesReportConfirmDialogProducts,
  },
})
export default class extends Vue {
  @Prop({ required: true }) private reportId?: string;
  private data = {} as get_agency_sales_report_detail.Response;
  private readonly thisMonth = monthStringFromIDate(
    stringToIDate(formatDate(new Date()))
  )!;
  private valid = true;
  private loading = true;
  private allProducts: Map<string, list_product_summaries.Product> = new Map();
  private operator = '';
  private operatorRules: ((v: string) => boolean | string)[] = [];
  private agentId = '';
  private agentName = '';
  private targetMonth = '';
  private reportDateMenu = false;
  private reportDate: string | null = null;
  private reportDateRules: ((v: string[]) => boolean | string)[] = [];
  private products: put_agency_sales_report.ReportedProduct[] = [];
  private soldAmountRules: ((v: number) => boolean | string)[] = [];
  private refundedAmountRules: ((v: number) => boolean | string)[] = [];
  private calculatedSalesProducts: Map<
    string,
    calculate_agency_inventory_sales.Product
  > = new Map();
  private note = '';
  private calculated = false;
  private redirectAfterUpdate = false;
  private dialog = false;
  private dialogConfirmHandler = this.resetDialog;
  private dialogTextTitle = '';
  private dialogSubmittedProducts: SalesReportSubmittedProduct[] = [];
  private dialogTextFooter = '';
  private showDialogRedirectCheckbox = true;

  get isDialogFullscreen() {
    return false && this.$vuetify.breakpoint.smAndDown;
  }

  get appLanguage() {
    return AppModule.language;
  }

  get canSubmit() {
    return this.valid;
  }

  @Watch('appLanguage')
  private onLangSelected() {
    (this.$refs.form as any).resetValidation();
  }

  created() {
    this.loadRules();
  }

  mounted() {
    this.fetchData();
  }

  private loadRules() {
    this.operatorRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Operated by'),
        }) as string),
    ];
    this.reportDateRules = [
      (v: string[]) =>
        (!!v && v.length > 0) ||
        (this.$t('{msg} is required', {
          msg: this.$t('Report date'),
        }) as string),
    ];
    this.soldAmountRules = [
      (v: number) =>
        !(isNaN(stringToNumber(v)) || v < 0) ||
        (this.$t('{msg} must be equal or greater than {num}', {
          msg: this.$t('Sold amount'),
          num: 0,
        }) as string),
    ];
    this.refundedAmountRules = [
      (v: number) =>
        !(isNaN(stringToNumber(v)) || v < 0) ||
        (this.$t('{msg} must be equal or greater than {num}', {
          msg: this.$t('Refunded amount'),
          num: 0,
        }) as string),
    ];
  }

  private async calculateStockAmount(
    submittedProducts: calculate_agency_inventory_sales.ReportedProduct[]
  ) {
    AppModule.StartProgress();
    try {
      const req = {
        agentId: this.agentId,
        targetMonth: monthStringToIDate(this.targetMonth),
        products: submittedProducts,
      } as calculate_agency_inventory_sales.Request;
      const res = await calculateAgencyInventorySales(req);
      this.calculatedSalesProducts = new Map(
        (res.products || []).map(p => [p.productId, p])
      );

      AppModule.StopProgress();
      this.loading = false;
      this.calculated = true;
      this.$toast.success(
        `${this.translateViewResource(
          'Succeeded calculating stock amount'
        ) as string}`,
        { icon: this.$route.meta.icon }
      );
    } catch (err) {
      AppModule.StopProgress();
      this.loading = false;
      this.calculated = false;
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Consignment sales stock amount'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private async submit(
    submittedProducts: put_agency_sales_report.ReportedProduct[]
  ) {
    AppModule.StartProgress();
    try {
      const req = {
        id: this.reportId,
        signedBy: this.operator,
        agentId: this.agentId,
        targetMonth: monthStringToIDate(this.targetMonth),
        products: submittedProducts,
        reportedAt: stringToIDate(formatDate(new Date())),
        version: this.data.version,
      } as put_agency_sales_report.Request;
      if (this.note) {
        req.note = this.note;
      }
      const res = await putAgencySalesReport(req);

      await this.postSubmit(res.reportId);
      AppModule.StopProgress();
      this.loading = false;
      this.$toast.success(
        `${this.translateViewResource(
          'Succeeded editing sales report'
        ) as string}. ${this.$t('Id')}: ${res.reportId}`,
        { icon: this.$route.meta.icon }
      );
    } catch (err) {
      AppModule.StopProgress();
      this.loading = false;
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private async postSubmit(reportId: string) {
    if (this.redirectAfterUpdate) {
      this.$nextTick(() => {
        this.$router.push(`/salesreport/${reportId}`);
      });
    } else {
      await this.fetchData();
    }
  }

  private getSubmittedReportProducts() {
    const submitted: put_agency_sales_report.ReportedProduct[] = [];
    this.products.forEach(p => {
      if (p.soldAmount > 0 || p.refundedAmount > 0) {
        submitted.push({
          productId: p.productId,
          soldAmount: p.soldAmount,
          refundedAmount: p.refundedAmount,
        });
      }
    });
    if (submitted.length === 0) {
      this.$toast.error(
        this.translateViewResource(
          'No valid report tickets submitted!'
        ) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
    return submitted;
  }

  private validate(): boolean {
    return (this.$refs.form as any).validate();
  }

  private resetValidation() {
    (this.$refs.form as any).resetValidation();
  }

  private async reset() {
    this.loadReportData();
    this.loadProducts();
  }

  private async fetchData() {
    this.loading = true;
    AppModule.StartProgress();

    try {
      this.data = await getAgencySalesReportDetail({
        reportId: this.reportId,
      } as get_agency_sales_report_detail.Request);
      this.loadReportData();

      const listProductsRes = await listProductSummaries({
        types: Object.values(ProductTypeEnum).filter(
          t => (t as ProductTypeEnum) === ProductTypeEnum.REAL_TICKET // TODO: check whether correct
        ),
        includeInactive: false,
      } as list_product_summaries.Request);
      this.allProducts = productById(listProductsRes.products);
      this.loadProducts();

      AppModule.StopProgress();
      this.loading = false;
    } catch (err) {
      AppModule.StopProgress();
      this.loading = false;
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: `${this.$t('Ticket')} & ${this.$t('Report')}`,
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private loadProducts() {
    this.products = [];
    this.allProducts.forEach(p => {
      const ep = this.data.products.find(
        editingProduct => editingProduct.productId === p.id
      );
      this.products.push({
        productId: p.id,
        soldAmount: ep ? ep.inventory.soldAmount : 0,
        refundedAmount: ep ? ep.inventory.refundedAmount : 0,
      });
    });
  }

  private loadReportData() {
    this.operator = this.data.signedBy;
    this.agentId = this.data.agentId;
    this.agentName = this.data.agentName;
    this.targetMonth = monthStringFromIDate(this.data.targetMonth)!;
    this.reportDate = stringFromIDate(this.data.reportedAt);
    if (this.data.note) {
      this.note = this.data.note;
    }
  }

  private getProductType(productId: string) {
    const product = this.allProducts.get(productId);
    if (product) {
      return this.$t(`ProductTypeEnum.${product.type}`);
    }
    return this.$t('ProductTypeEnum.UNKNOWN_PRODUCT_TYPE');
  }

  private getProductName(productId: string) {
    const product = this.allProducts.get(productId);
    if (product) {
      return `${
        this.$i18n.locale !== 'ja' && this.allProducts.get(productId)!.nameEn
          ? this.allProducts.get(productId)!.nameEn
          : this.allProducts.get(productId)!.name
      }${
        this.allProducts.get(productId)!.fiscalYear === 0
          ? ''
          : ' [' + this.allProducts.get(productId)!.fiscalYear + ']'
      }`;
    }
    return '';
  }

  private getNetSoldAmountText(productId: string) {
    if (this.calculatedSalesProducts.has(productId)) {
      return `${
        this.calculatedSalesProducts.get(productId)!.inventory.netSoldAmount
      }`;
    }
    return '';
  }

  private getCarryOverAmountText(productId: string) {
    if (this.calculatedSalesProducts.has(productId)) {
      return `${
        this.calculatedSalesProducts.get(productId)!.inventory.carryOverAmount
      }`;
    }
    return '';
  }

  private getStockAmountText(productId: string) {
    if (this.calculatedSalesProducts.has(productId)) {
      return `${
        this.calculatedSalesProducts.get(productId)!.inventory.stockAmount
      }`;
    }
    return '';
  }

  private resetDialog() {
    this.dialog = false;
    this.dialogTextTitle = '';
    this.dialogSubmittedProducts = [];
    this.dialogTextFooter = '';
    this.showDialogRedirectCheckbox = true;
    this.$nextTick(() => {
      this.dialogConfirmHandler = this.resetDialog;
    });
  }

  private showDialogForCalculate() {
    const submittedReportProducts = this.getSubmittedReportProducts();
    if (submittedReportProducts.length === 0) {
      return;
    }

    this.dialogTextTitle = `${(this.$t('Fetch {msg}', {
      msg: this.$t('Consignment sales stock amount'),
    }) as string).toLowerCase()}:`;
    const products: SalesReportSubmittedProduct[] = [];
    submittedReportProducts.forEach(p => {
      products.push({
        productId: p.productId,
        productName: this.allProducts.get(p.productId)!.name,
        soldAmount: p.soldAmount,
        refundedAmount: p.refundedAmount,
      });
    });
    this.dialogSubmittedProducts = products;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showDialogRedirectCheckbox = false;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.calculateStockAmount(submittedReportProducts);
    };
    this.dialog = true;
  }

  private showDialogForSubmit() {
    const submittedReportProducts = this.getSubmittedReportProducts();
    if (submittedReportProducts.length === 0) {
      return;
    }

    this.dialogTextTitle = `${this.translateRouteTitle(
      this.$route.meta.title
    )}:`;
    const products: SalesReportSubmittedProduct[] = [];
    submittedReportProducts.forEach(p => {
      products.push({
        productId: p.productId,
        productName: this.allProducts.get(p.productId)!.name,
        soldAmount: p.soldAmount,
        refundedAmount: p.refundedAmount,
      });
    });
    this.dialogSubmittedProducts = products;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showDialogRedirectCheckbox = true;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.submit(submittedReportProducts);
    };
    this.dialog = true;
  }

  private getDialogTextProducts(
    products: put_agency_sales_report.ReportedProduct[],
    allProducts: Map<string, list_product_summaries.Product>
  ) {
    const dialogTextProducts: string[] = [];
    const soldAmountText = this.$t('Sold amount');
    const refundedAmountText = this.$t('Refunded amount');
    for (let i = 0; i < products.length; i++) {
      if (!(products[i].soldAmount > 0 || products[i].refundedAmount > 0)) {
        continue;
      }
      const product = allProducts.get(products[i].productId);
      let text = product ? `${product.name}:` : '';
      products[i].soldAmount > 0 &&
        (text += ` ${soldAmountText}${products[i].soldAmount}`);
      products[i].refundedAmount > 0 &&
        (text += ` ${refundedAmountText}${products[i].refundedAmount}`);
      if (i !== products.length - 1) {
        text += ', ';
      }
      dialogTextProducts.push(text);
    }
    return dialogTextProducts;
  }

  private allowedMonths(val: string | null) {
    return !val || val <= this.thisMonth;
  }

  private translateViewResource(
    resource: string,
    options?: { [key: string]: any }
  ) {
    return translateViewResource(
      this.$i18n,
      this.$options.name as string,
      resource,
      options
    );
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
